<template>
    <template v-for="(form, formindex) in formobj" :key="formindex">
        <template v-if="form.type === 'group' && form.is_show === true">
            <el-tabs class="form-tabs" type="border-card">
                <el-tab-pane v-for="(tab, tabindex) in form.options" :key="tabindex" :label="tabindex">
                    <template v-for="(fm, fmindex) in tab" :key="fmindex">
                        <form-item :formobj="formobj" :forms="fm" />
                    </template>
                </el-tab-pane>
            </el-tabs>
        </template>
        <template v-else>
            <form-item v-if="form.is_show === true" :formobj="formobj" :forms="form" />
        </template>
    </template>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject, watch } from 'vue'
    import FormItem from './item'
    export default defineComponent({
        components: {
            FormItem
        },
        props: {
            formobj: {
                type: [Array, Object],
                default: () => {}
            }
        }
    })
</script>

<style scoped>

</style>
